function getShader(gl, source, type) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        alert("An error occurred compiling the shaders: " + gl.getShaderInfoLog(shader));
        return null;
    }
    return shader;
}
export function compileShaders(gl, _fragmentShader, _vertexShader) {
    const fragmentShader = getShader(gl, _fragmentShader, gl.FRAGMENT_SHADER);
    const vertexShader = getShader(gl, _vertexShader, gl.VERTEX_SHADER);
    return { fragmentShader, vertexShader };
}
export function cleanProgram(glConfig) {
    var _a;
    (_a = glConfig === null || glConfig === void 0 ? void 0 : glConfig.gl) === null || _a === void 0 ? void 0 : _a.deleteProgram(glConfig.shaderProgram);
}
export function hexToRgbA(hex) {
    hex = hex.replace("#", "");
    const r = parseInt(hex.substring(0, hex.length / 3), 16) / 255;
    const g = parseInt(hex.substring(hex.length / 3, (2 * hex.length) / 3), 16) / 255;
    const b = parseInt(hex.substring((2 * hex.length) / 3, (3 * hex.length) / 3), 16) /
        255;
    return [r, g, b, 1.0];
}
//# sourceMappingURL=utils.js.map